export default {
  Amex: 'amex',
  Diners: 'diners',
  Elo: 'elo',
  Hipercard: 'hipercard',
  Hiper: 'hiper',
  Mastercard: 'mastercard',
  Master: 'master',
  Visa: 'visa',
};
